import routes from '../helpers/ApplicationRoutes';

export const getOrganizations = state => {
    const { currentOrganizations } = state;
    if (!currentOrganizations.items) {
        return undefined;
    }
    return currentOrganizations.items.map(orgId =>
        getOrganization(state, orgId),
    );
};

export const getCurrentOrganizationId = state => {
    const { pathname } = state.router.location;
    const params = routes.organization.getParams(pathname);
    return params ? +params.organizationId : undefined;
};

export const getOrganization = (
    state,
    organizationId = getCurrentOrganizationId(state),
) => {
    const organization = state.db.organizations[organizationId];
    if (!organization) {
        return undefined;
    }
    return {
        ...organization,
        visibleInApplications: organization.visibleInApplications
            .filter(appId => !state.db.applications[appId].hide)
            .map(appId => state.db.applications[appId]),
    };
};

export const getIsCurrentUserAdminForOrganization = (
    state,
    organizationId = getCurrentOrganizationId(state),
) => {
    const organization = getOrganization(state, organizationId);
    return organization && organization.currentUserIsAdmin;
};

export const getIsLoadingOrganizations = state =>
    !!state.currentOrganizations.loadingOrganizations;



// WEBPACK FOOTER //
// ./src/selectors/organizationSelectors.js